import { combineReducers } from "redux";
import AuthReducer from "./authReducer";
import ReduxFormReducer from "./reduxFormReducer";
import gettingStartedWizardReducer from "./gettingStartedWizardReducer";
import profileScreenReducer from "./profileScreenReducer";
import connectionsReducer from "./connectionsReducer";
import intentsReducer from "./intentsReducer";
import skillReducer from "./skillReducer";
import layoutReducer from "./layoutReducer";
import dashboardReducer from "./dashboardReducer";
import commonReducer from "./commonReducer";
import customSlotsReducer from "./customSlotsReducer";
import chatReducer from "./chatReducer";
import subscriptonsReducer from "./subscriptionsReducer";
import utterance from "./utterance";
import chatbotSettingsReducer from "./chatbotSettingsReducer";
import faqCmsReducer from "./faqCmsReducer";
import suggestionsReducer from "./suggestionsReducer";

const appReducer = combineReducers({
  form: ReduxFormReducer,
  auth: AuthReducer,
  profile: profileScreenReducer,
  gettingStartedWizard: gettingStartedWizardReducer,
  connections: connectionsReducer,
  intents: intentsReducer,
  layout: layoutReducer,
  skill: skillReducer,
  dashboard: dashboardReducer,
  common: commonReducer,
  customSlots: customSlotsReducer,
  chat: chatReducer,
  subscriptions: subscriptonsReducer,
  utterance: utterance,
  chatbotSettings: chatbotSettingsReducer,
  faqCms: faqCmsReducer,
  suggestions: suggestionsReducer
});

// clear all session on unauth_user action
const rootReducer = (state, action) => {
  if (action.type.toUpperCase() === "UNAUTH_USER") {
    const { routing } = state;
    state = { routing };
  }
  return appReducer(state, action);
};

export default rootReducer;
